/* =========================================================
   Theme JS — vanilla JS, no build step required
========================================================= */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('.header-menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------- Search drawer ---------- */
  var searchToggle = document.querySelector('.header-search-toggle');
  var searchDrawer = document.getElementById('HeaderSearch');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function () {
      var isOpen = !searchDrawer.hidden;
      searchDrawer.hidden = isOpen;
      searchToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        var input = searchDrawer.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('.product-gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var targetId = thumb.getAttribute('data-target-media-id');
      var gallery = thumb.closest('.product-gallery');
      if (!gallery) return;

      gallery.querySelectorAll('.product-gallery-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      gallery.querySelectorAll('.product-gallery-slide').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === targetId);
      });
    });
  });

  /* ---------- Product option selection ---------- */
  document.querySelectorAll('.product-form').forEach(function (form) {
    var optionGroups = form.querySelectorAll('.product-option-values');
    if (!optionGroups.length) return;

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.option-value');
        if (!btn) return;
        group.querySelectorAll('.option-value').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        // A production build should look up the matching variant via the
        // product's variant JSON (window.__productVariants) and update the
        // hidden variant id input, price, and availability accordingly.
      });
    });
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('.product-form, .product-card-quick-add').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.setAttribute('data-cart-count', cart.item_count);
          });
          document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          alert((err && err.description) || 'Unable to add this item to your cart.');
        });
    });
  });

  /* ---------- Cart quantity / remove (cart page) ---------- */
  document.querySelectorAll('.cart-item-quantity').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: input.value })
      }).then(function () { window.location.reload(); });
    });
  });

  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Build gallery before/after slider ---------- */
  document.querySelectorAll('.build-gallery-compare').forEach(function (compare) {
    var after = compare.querySelector('.build-gallery-after');
    var before = compare.querySelector('.build-gallery-before');
    if (!after || !before) return;
    compare.addEventListener('mouseenter', function () { after.style.opacity = '1'; });
    compare.addEventListener('mouseleave', function () { after.style.opacity = ''; });
  });
})();
